import React from 'react';
import { connect } from 'react-redux';
import { setScroll, setSize, setLoaded } from '../../redux/WindowEvents/WindowEventActions';
import { isServer } from '../../tools/Utils';

class _WindowEventHandler extends React.Component
{
	componentDidMount()
	{
		if(isServer)
			return;
			
		const { load, scroll, resize } = this.props;

		if(load)
			window.addEventListener("load", this.onLoad, {
				capture: true,
				passive: true
			} );
		if(scroll)
			window.addEventListener('scroll', this.onScroll, false);
		if(resize)
			window.addEventListener('resize', this.onResize);
	}
	
	componentWillUnmount()
	{
		const { load, scroll, resize } = this.props;
		
		if(load)
			window.removeEventListener("load", this.onLoad);
		if(scroll)
			window.removeEventListener('scroll', this.onScroll);
		if(resize)
			window.removeEventListener('resize', this.onResize);
	}

	updateScroll = () =>
	{
		// if(this.sleep) return;

		this.props.setScroll(window.scrollY,window.scrollX);

		// this.sleep=true

		// setTimeout(()=>this.sleep=false, 1);
	}

	timestamp = Date.now();
	onScroll = event => {
			
		const stamp = Date.now();
		if (stamp - this.timestamp >= 10)
		{
			window.requestAnimationFrame(this.updateScroll);
			this.timestamp = stamp;
		}
	};

	onResize = (e) =>
	{
		this.props.setSize(window.innerWidth,window.innerHeight);
	}

	onLoad = () =>
	{
		this.props.setSize(window.innerWidth,window.innerHeight);
		this.props.setLoaded(true);

		window.removeEventListener('load', this.onLoad);
	}
	render()
	{
		return null;
	}
}


export const WindowEventHandler = connect(
	undefined,
	(dispatch, ownProps) =>
	{
		return {
			setScroll:(y,x)=>dispatch(setScroll(y,x)),
			setSize:(w,h)=>dispatch(setSize(w,h)),
			setLoaded:(loaded)=>dispatch(setLoaded(loaded))
			};
	}
)(_WindowEventHandler);
